import React from 'react';
import ReactDOM from 'react-dom';
import { BaseButton } from '@repo/common';
import { clampPopoverLeft } from '../Common/popover';

/**
 * 회원 행의 ⋯ 버튼 아래에 뜨는 메뉴. 결제 목록의 OptionList와 같은 자리·모양.
 * @param {{ key: string, label: string, danger?: boolean, onSelect: () => void }[]} options
 */
function UserOptionList({ anchorRect, options, onClose }) {
  if (!anchorRect) return null;

  const MENU_WIDTH = 220;
  const left = clampPopoverLeft(anchorRect.right - 24, MENU_WIDTH);

  return ReactDOM.createPortal(
    <>
      <div
        className='fixed inset-0 z-[999999] bg-transparent'
        onClick={(e) => {
          e.stopPropagation();
          onClose?.();
        }}
      />

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'fixed',
          top: anchorRect.bottom + 6,
          left,
          width: MENU_WIDTH,
        }}
        className='bg-grayscale-gray00 border border-grayscale-gray02 rounded-lg shadow-popup-04 z-[1000000]'
      >
        <div className='bg-grayscale-gray00 rounded-lg p-2'>
          <ul className='flex flex-col'>
            {options.map(({ key, label, danger, onSelect }) => (
              <li key={key}>
                <BaseButton
                  type='text'
                  size='m'
                  hideIcon
                  width='100%'
                  leftalign={true}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onSelect();
                  }}
                  bgclass='bg-grayscale-gray00 border border-grayscale-gray00'
                  textclass={`typo-b14Strong ${danger ? 'text-text-failed' : ''}`}
                  hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                  activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                >
                  {label}
                </BaseButton>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>,
    document.body,
  );
}

export default UserOptionList;
